// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"09c2d0bb","249":"549884ec","584":"e0910883","666":"737b8edd"}[chunkId] + ".chunk.js";
};